import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_project_navigation = _resolveComponent("project-navigation")
  const _component_project_user_pledges = _resolveComponent("project-user-pledges")

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { id: "navigation" }, null, -1 /* CACHED */)),
    _createVNode(_component_project_navigation, {
      items: $props.navigation.items
    }, null, 8 /* PROPS */, ["items"]),
    _createVNode(_component_project_user_pledges, {
      "add-new-items-url": $props.addNewItemsUrl,
      "empty-state-description": $props.emptyStateDescription,
      "is-open-for-orders": $props.isOpenForOrders,
      "selected-order-code": $props.selectedOrderCode
    }, null, 8 /* PROPS */, ["add-new-items-url", "empty-state-description", "is-open-for-orders", "selected-order-code"])
  ]))
}